import { Instructions } from "./instructions";

export const ChatTypes = {
  // "Get Cosultation summary": Instructions.insConsultation,
  "Generate SOAP note": Instructions.insSoapNote,
  "Generate Detailed Note": Instructions.insConsultationDetailed,
  // "Generate Psychiatric Note": Instructions.insConsultationPsy,
} as const;

export type ChatTypeKey = keyof typeof ChatTypes;
export type ChatTypeValue = (typeof ChatTypes)[ChatTypeKey];
